export const SOCIAL_CONFIG = {
  TOP_BETS_LIMITER: 10
}

export const BET_CONFIG = {
  DEFAULT_BETTING_OPEN_WINDOW_SEC: 20,
  DEFAULT_BETTING_CLOSING_WINDOW_SEC: 5,
  DEFAULT_SETTLED_WINDOW_SEC: 7,
  WAIT_FOR_ACCEPTANCE_MS: 8500,
  EXOTIC_BET_MIN_MARBLES: 3,
  BONUS_DISPLAY_HIDE_DELAY_MS: 3000
}

export const AUTO_BET_CONFIG = {
  BET_COUNTDOWN: 3
}

export const GAME_CARD_CONFIG = {
  FAST_RACE_THRESHOLD: 13
}

export const ASSETS = {
  SOUNDS_CACHE_BUSTER: '1769103381000',
  NOTIFICATIONS_CACHE_BUSTER: '1765250421000'
}

export const HISTORY = {
  BETS_PER_PAGE: 10,
  /** Rounds pulled once when the past-races panel opens — the stats window.
   *  A few hundred rounds is a couple of hours of play on every game, which
   *  is what makes the numbers useful for a player reading recent form. */
  DEEP_ROUNDS: 200,
  /** Rows visible before "show more". */
  ROUNDS_VISIBLE: 20,
  /** Rows revealed per "show more" press. */
  ROUNDS_STEP: 20
}

export const FALLBACK_DEFAULT_BET_MULTIPLIER = 5
